import { css } from 'styled-components'
import { mobileCSS } from '@measures/responsive'
const logoPaddingDesktopTablet = '30px'
const logoPaddingMobile = '30px'

//TODO: do we really need this ???
const GlobalVideoJSStyles = css`
  .video-js {
    // stylelint-disable declaration-no-important
    .vjs-overlay {
      background-color: transparent;
      position: absolute;

      &.vjs-hidden {
        display: block !important;
      }
    }

    &.vjs-ad-playing {
      .vjs-overlay {
        &.vjs-hidden {
          display: none !important;
        }
      }
    }

    .vjs-overlay-top-left {
      top: ${logoPaddingDesktopTablet};
      left: ${logoPaddingDesktopTablet};

      ${mobileCSS(css`
        top: ${logoPaddingMobile};
        left: ${logoPaddingMobile};
      `)}
    }

    .vjs-overlay-top-right {
      top: ${logoPaddingDesktopTablet};
      right: ${logoPaddingDesktopTablet};

      ${mobileCSS(css`
        top: ${logoPaddingMobile};
        right: ${logoPaddingMobile};
      `)}
    }

    .vjs-overlay-bottom-left {
      bottom: ${logoPaddingDesktopTablet};
      left: ${logoPaddingDesktopTablet};

      ${mobileCSS(css`
        bottom: ${logoPaddingMobile};
        left: ${logoPaddingMobile};
      `)}
    }

    .vjs-overlay-bottom-right {
      bottom: ${logoPaddingDesktopTablet};
      right: ${logoPaddingDesktopTablet};

      ${mobileCSS(css`
        bottom: ${logoPaddingMobile};
        right: ${logoPaddingMobile};
      `)}
    }

    .vjs-contextmenu-ui-menu {
      display: none;
    }
  }

  body.video-overlay-shown {
    background-color: #000;
    overflow: hidden;
  }
`

export default GlobalVideoJSStyles
